export default "__VITE_ASSET__7i4rSSZD__"